/* eslint-disable */
import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import jwt_decode from "jwt-decode";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import showformmodel from "../showformmodel/showformmodel.vue"

// import from 'jstree'
export default {
  components: {
    VPagination,
    showformmodel
  },
  data() {
    return {
      status:{
        "Visit Ongoing":'success',
        "Enrolled":'info',
        "Pre-Screening":'warning',
        "Screening":'warning',
        "Follow-up":'info',
        "Completed":'success',
        "Withdrawn":'danger',
        "Lost to Follow-up": 'danger',
        "Discontinued":'danger',
        "New":'danger'
      },
      formstatus:{
        "New":'info',
        "Verified":'success',
        "Unverified":'warning',
        "Discontinued":'danger',
        "Pending":'danger',
        "Overdue":'danger',
        "Imminent":'warning',
        "Completed":'success',
        "In Progress":'info',
        "Blank":'warning',
      },
      notcompletedforms:[],
      completedforms:[],
      formlist:[],
      baseurl: process.env.VUE_APP_Service_URL,
      subjectid:"",
      setshowFormModal:false,
      defaultDate:"",
    };
  },

  async mounted() {
     this.defaultdate = localStorage.getItem("dateformat");
    window.addEventListener("studyIdChanged", async (event) => {
    await this.listforms();

    });
     await this.getsubject();
    await this.listforms();

    
  },
  unmounted(){
    store.dispatch("setopentreeforsubjectschedule", false);
  },
  methods: {
    async getsubject(){
          const idtoken = store.getters.getIdToken;
            await axios
                .get(`${this.baseurl}/forms/epro/getsubbyemail`, {
                    headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    if (response.data) {
                        this.subjectid = response.data.id;
                    } else {
                        console.log("No ePRO forms found");
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
    },
    filter(data) {
           if (data) {
             return moment(data).format(this.defaultdate);
           }
         },
    async listforms() {
            const idtoken = store.getters.getIdToken;
            const stdid = store.getters.getStudyIs;
            await axios
                .get(`${this.baseurl}/forms/epro/getsubjectschedules?studyid=${stdid}&subjectid=${this.subjectid}&isEpro=true&SortProperty=visitDate&SortOrder=0`, {
                    headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    if (response.data) {
                        this.formlist = response.data.entities;
                        this.listnotcompletedforms();
                        this.listcompletedforms();
                    } else {
                        console.log("No ePRO forms found");
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },

 async listnotcompletedforms() {
    this.notcompletedforms = this.formlist.filter(
      f => f.formStatus !== "Completed"
    );
  },

  async listcompletedforms() {
    this.completedforms = this.formlist
    .filter(f => f.formStatus === "Completed")
    .sort((a, b) => new Date(b.visitCompletedDate) - new Date(a.visitCompletedDate));
  },

    async EditForm(entry, isPatientVisit) {
      const stdid = store.getters.getStudyIs;
      if(entry.formId != null && entry.formId != "" && entry.formId != undefined){
      this.$router.push(`/editForm/subjectdiaries/${entry.formId}/${isPatientVisit}`);
    }
    else{
      let tempvar = {
          "Siteid": entry.siteId,
          "Subject_id": entry.patientId,
          "Visitname": entry.visitName,
          "Visitno": entry.visitNo,
          "sheduleId": entry.id
        }

      await store.dispatch("commitvisitdetails", tempvar);
      await store.dispatch("setautofillsiteid", entry.siteCode);
      await store.dispatch("setautofillsubjectid", entry.patientNo);
      await store.dispatch("setautofillenabled", "true");
      this.$router.push(`/form/${isPatientVisit}/${entry.templateId}/${stdid}/0 `);
    }
    },
    async showformmodel(currentform){
      console.log("currentform",currentform);
      this.currentform = currentform;
          this.setshowFormModal = true;
      },
      async closeformModal(){
  this.currentform = "";
    this.setshowFormModal = false;
  },
  },
};
